import { render } from "./creditcard.vue?vue&type=template&id=22ed23b6"
import script from "./creditcard.vue?vue&type=script&lang=js"
export * from "./creditcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__